import { ItemType } from '@vista-digital/ocapi-types/v1';
import { runInAction } from 'mobx';
import { addMonetaryValues, getZeroMonetaryValue, multiplyMonetaryValue } from '../../../../utils/monetary-value-utils';
import { isDiscountItemPrice } from '../../../sales-data/utils/items/item-price-utils';
export const updateInProgressItemTotalSavings = (inProgressItem) => {
    switch (inProgressItem.type) {
        case ItemType.Normal:
            return updateInProgressNormalItemTotalSavings(inProgressItem);
        case ItemType.ParentSales:
            return updateInProgressParentSalesItemTotalSavings(inProgressItem);
        default:
            throw 'Unsupported item type';
    }
};
const updateInProgressNormalItemTotalSavings = (inProgressItem) => {
    const itemPrice = inProgressItem.selectedPrice;
    runInAction(() => {
        if (!isDiscountItemPrice(itemPrice)) {
            inProgressItem.totalSavings = getZeroMonetaryValue();
            return;
        }
        inProgressItem.totalSavings = addMonetaryValues(Object.assign({}, itemPrice.discount.amountSaved), ...inProgressItem.modifierGroups.map(modifierGroup => modifierGroup.totalSavings));
    });
};
const updateInProgressParentSalesItemTotalSavings = (inProgressItem) => {
    const { selectedInProgressItems } = inProgressItem;
    runInAction(() => {
        if (!selectedInProgressItems) {
            inProgressItem.totalSavings = getZeroMonetaryValue();
        }
        else {
            inProgressItem.totalSavings = Object.values(selectedInProgressItems).reduce((total, option) => {
                updateInProgressNormalItemTotalSavings(option.item);
                return addMonetaryValues(total, option.item.totalSavings && multiplyMonetaryValue(option.item.totalSavings, option.quantity));
            }, getZeroMonetaryValue());
        }
    });
};
